/**
 * Retrieves vehicle nameplate information when user selects element
 * on SRP.
 *
 * @param {Element} element The element selected
 * @returns {string} The vehicle nameplate, undefined if not found
 */
export default (element) => {
	const vehicleData = {};
	const vehicleCard = element.closest('.vehicle-card[data-uuid]');

	const { uuid } = vehicleCard?.dataset || {};
	const { vehicles } = window?.DDC?.dataLayer || {};
	let vehicle;
	let nameplate;
	let modelYear;

	if (uuid && vehicles) {
		vehicle = vehicles.find((v) => v.uuid === uuid);
	} else if (vehicleCard) {
		nameplate = `${vehicleCard.dataset.make} ${vehicleCard.dataset.model}`;
		modelYear = `${vehicleCard.dataset.year}`;
	}

	if (vehicle || (nameplate && modelYear)) {
		vehicleData.nameplate = nameplate || `${vehicle.make} ${vehicle.model}`;
		vehicleData.modelYear = modelYear || `${vehicle.modelYear}`;
	}

	return vehicleData;
};
